<div fxLayout="row" fxLayoutAlign="center center">
  <ng-container [ngSwitch]="partnership?.status">
    <mat-card fxFlex *ngSwitchCase="partnershipStatus.Requested">
      <mat-card-header>
        <mat-card-title>Partnership Agreement</mat-card-title>
        <mat-card-subtitle>{{latestVersion}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div fxLayout="row" fxLayoutAlign="center center">
          <div class="pdf-container" style="max-height: 500px; overflow-y: auto; border: 1px solid #ddd;">
            <app-pdf-viewer *ngIf="!!latestAgreementUrl" (documentReadEvent)="handleDocumentReadEvent($event)" pdfUrl="{{latestAgreementUrl}}" embedMode="IN_LINE"></app-pdf-viewer>
          </div>
        </div>
        <div class="accept-agreement-container" fxLayout="column" fxLayoutAlign="end end" fxLayoutAlign.lt-sm="start center" fxLayoutGap="10px">
          <div>
            <strong>Terms of Use for the Friends Licence</strong>
            <ul>
              <li><strong>Control of Assets</strong>: The Friends Licence grants situ Members non-exclusive, revocable access to visual assets provided by other Members, limited to the specified products, ranges, or homes as determined by the asset owner.</li>
              <li><strong>Permission Requirements</strong>: It is mandatory for the asset owner (e.g., a supplier or builder) to initiate the “friending” process and provide explicit permission before any visual asset can be used by another Member.</li>
              <li><strong>Rights Reserved</strong>: The asset owner retains full control over the usage of their visual assets and may revoke access at any time.</li>
              <li><strong>Scope of Usage</strong>: Approved usage is confined to the context and range defined by the asset owner during the initial assignment, with any further alterations or expansions requiring new permissions.</li>
            </ul>

          </div>
          <p>Please confirm your agreement to these terms by checking the box below:</p>
          <mat-checkbox [(ngModel)]="acceptPartnershipAgreement">I agree to the Terms of Use for the situ Friends Licence</mat-checkbox>
          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutAlign.lt-sm="center center" fxLayoutGap="10px">
            <button [disabled]="!acceptPartnershipAgreement || loadingAccept || !documentRead" [class.button-spinner]="loadingAccept" mat-raised-button color="primary" (click)="acceptAgreement()">
              <mat-icon>link</mat-icon> Accept
            </button>
            <button mat-raised-button color="basic" [disabled]="loadingDecline" [class.button-spinner]="loadingDecline" (click)="declineAgreement()">
              <mat-icon>link_off</mat-icon> Decline
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <ng-container *ngSwitchCase="partnershipStatus.Approved">
      <ng-container *ngIf="partnership?.status === partnershipStatus.Approved || partnership?.status === partnershipStatus.Reconnected">
        
        <mat-card fxFlex>
          <mat-card-content>
            <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
              <label>Partnership products</label>
            </div>
            <product-catalog-list *ngIf="partnershipInitalised"
              [companyIdFilter]="getOtherCompanyId(partnership)"
              [productRangeIdFilter]="rangeFilterId"
              [isCatalog]="true">
            </product-catalog-list>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
